export function getColumnKey(column, defaultKey) {
    if ('key' in column && column.key !== undefined && column.key !== null) {
        return column.key;
    }
    if (column.dataIndex) {
        return (Array.isArray(column.dataIndex) ? column.dataIndex.join('.') : column.dataIndex);
    }
    return defaultKey;
}
export function getColumnPos(index, pos) {
    return pos ? `${pos}-${index}` : `${index}`;
}
export function renderColumnTitle(title, props) {
    if (typeof title === 'function') {
        return title(props);
    }
    return title;
}
const findTheadLastTr = (tableBody) => {
    var _a;
    const tableNode = (tableBody === null || tableBody === void 0 ? void 0 : tableBody.classList.contains('bonree-table-body'))
        ? tableBody.previousElementSibling
        : tableBody;
    const theadTrs = ((_a = tableNode === null || tableNode === void 0 ? void 0 : tableNode.querySelector('.bonree-table-thead')) === null || _a === void 0 ? void 0 : _a.querySelectorAll('tr')) || [];
    return (theadTrs === null || theadTrs === void 0 ? void 0 : theadTrs.length) ? theadTrs[theadTrs.length - 1] : null;
};
// 找前一个dom
const findPreviousDom = (dom, tableBody) => {
    const previous = dom.previousElementSibling;
    if (previous) {
        if (getComputedStyle(previous).display === 'none') {
            return findPreviousDom(previous);
        }
        if (previous.classList.contains('bonree-table-measure-row')) {
            return findTheadLastTr(tableBody);
        }
        return previous;
    }
    return findTheadLastTr(tableBody);
};
// 找下一个level=0的dom的前一个dom
const findNextTopLevelDomPreious = (dom) => {
    const next = dom.nextElementSibling;
    const nextNext = next === null || next === void 0 ? void 0 : next.nextElementSibling;
    if (next) {
        if (nextNext) {
            if (/\.*row-level-0\.*/.test(nextNext.classList.value)) {
                return next;
            }
            return findNextTopLevelDomPreious(next);
        }
        return next;
    }
    return null;
};
// 清除展开相关类名
export const clearExpandClassName = (tableBody) => {
    var _a, _b;
    tableBody === null || tableBody === void 0 ? void 0 : tableBody.querySelectorAll(`tr`).forEach(dom => {
        dom.classList.remove(`expand-previous`);
        dom.classList.remove(`expand-start`);
        dom.classList.remove(`expand-end`);
    });
    // 当设置scroll属性时，表头和表内容的DOM结构不同，其表头与表内容各含有<table>标签
    if (tableBody === null || tableBody === void 0 ? void 0 : tableBody.classList.contains('bonree-table-body')) {
        const theadTrs = ((_b = (_a = tableBody === null || tableBody === void 0 ? void 0 : tableBody.previousElementSibling) === null || _a === void 0 ? void 0 : _a.querySelector('.bonree-table-thead')) === null || _b === void 0 ? void 0 : _b.querySelectorAll('tr')) || [];
        const theadLastTr = (theadTrs === null || theadTrs === void 0 ? void 0 : theadTrs.length) ? theadTrs[theadTrs.length - 1] : null;
        theadLastTr === null || theadLastTr === void 0 ? void 0 : theadLastTr.classList.remove(`expand-previous`);
    }
};
// 通过ExpandedRowKeys计算每行类名
export const computedTableClassNameByExpandedRowKeys = (flatData, expandedRowKeys, expandType, getRowKey, tableBody) => {
    clearExpandClassName(tableBody);
    flatData === null || flatData === void 0 ? void 0 : flatData.forEach(record => {
        requestAnimationFrame(() => {
            const key = getRowKey(record);
            if (expandedRowKeys === null || expandedRowKeys === void 0 ? void 0 : expandedRowKeys.includes(key)) {
                if (expandType === 'nest') {
                    tableBody === null || tableBody === void 0 ? void 0 : tableBody.querySelectorAll(`tr`).forEach(dom => {
                        const keyRow = dom.dataset.rowKey;
                        if (keyRow === String(key) && /\.*row-level-0\.*/.test(dom.classList.value)) {
                            dom.classList.add(`expand-start`);
                            const previous = findPreviousDom(dom, tableBody);
                            previous === null || previous === void 0 ? void 0 : previous.classList.add(`expand-previous`);
                            const next = findNextTopLevelDomPreious(dom);
                            next === null || next === void 0 ? void 0 : next.classList.add(`expand-end`);
                        }
                    });
                }
                else if (expandType === 'row') {
                    tableBody === null || tableBody === void 0 ? void 0 : tableBody.querySelectorAll(`tr`).forEach(dom => {
                        const keyRow = dom.dataset.rowKey;
                        if (keyRow === String(key)) {
                            dom.classList.add(`expand-start`);
                            const previous = findPreviousDom(dom, tableBody);
                            previous === null || previous === void 0 ? void 0 : previous.classList.add(`expand-previous`);
                            const nextDom = dom.nextElementSibling;
                            nextDom === null || nextDom === void 0 ? void 0 : nextDom.classList.add(`expand-end`);
                        }
                    });
                }
            }
        });
    });
};
// 判断是否有横向滚动条
export const judageScrollX = (tableBody) => {
    if (tableBody) {
        if (tableBody.scrollWidth > tableBody.clientWidth) {
            return true;
        }
    }
    return false;
};
